import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { CanvasAddElementMenu } from './CanvasAddElementMenu';
import { useCanvasStructure } from './CanvasStructureContext';

/**
 * The "+ Add element" button inside an empty column on the block editor canvas. Opens the element
 * menu (Heading, Subheading, Label + value, Variable, Text, Image, Logo) and inserts into that
 * column. Absolutely positioned inside the column's reserved empty height.
 */
export function CanvasEmptyColumnAdd({ sectionId, column, testId }: { sectionId: string; column: number; testId: string }) {
  const api = useCanvasStructure();
  if (!api) return null;
  return (
    <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CanvasAddElementMenu
        slot={{ sectionId, column, index: 0 }}
        testId={testId}
        renderTrigger={({ onClick, expanded }) => (
          <Box
            component="button"
            type="button"
            onClick={onClick}
            aria-haspopup="menu"
            aria-expanded={expanded}
            aria-label={`Add element to column ${column + 1}`}
            data-testid={`${testId}:button`}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              px: '8px',
              py: '2px',
              border: 0,
              borderRadius: 'var(--border-radius-none)',
              bgcolor: 'transparent',
              color: 'var(--text-caption)',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              '&:hover': { color: 'var(--border-focus)' },
              '&:focus-visible': { outline: 'var(--border-width-sm) solid var(--border-focus)', outlineOffset: 1 }
            }}
          >
            <AddIcon sx={{ fontSize: 14 }} aria-hidden />
            Add element
          </Box>
        )}
      />
    </Box>
  );
}
